import React from 'react';

import { addSubtitlesToYoutubeVideos } from '@app/components/LocalCommon/Utils/VideoExtensions';
import '@app/scss/components/videoEmbed.scss';

interface VideoEmbedProps {
	text?: string | JSX.Element;
	videoSrc?: string;
	videoTitle?: string;
}

const VideoEmbed: React.FC<VideoEmbedProps> = ({ text, videoSrc, videoTitle }) => {
	return (
		<section className={`video-embed ${videoSrc ? 'video-embed_with-video' : ''}`}>
			{text && <div className="video-embed__text">{text}</div>}
			{videoSrc && (
				<div className="video-embed-block">
					<iframe
						className="video-embed-block__video"
						src={addSubtitlesToYoutubeVideos(videoSrc)}
						width="697"
						height="392"
						allow="autoplay; fullscreen"
						allowFullScreen
						title={videoTitle}
					/>
					{videoTitle && <p className="video-embed-block__title">{videoTitle}</p>}
				</div>
			)}
		</section>
	);
};

export default VideoEmbed;
